export default class SystemNotification {
    systemNotificationId: number;
    title : string;
    startDate : Date;
    endDate : Date;
    body : string;
    displayType : SystemNotificationDisplayType;
    primaryActionText : string;
    primaryActionUrl : string;
    closeButtonText : string;
    dontRemindButtonText : string;
    verifyCert : boolean;
    preCert : boolean;
    physicianPortal : boolean;
    boardCert : boolean;
}

export enum SystemNotificationDisplayType {
    Banner = 1,
    Modal = 2
}

export enum SystemNotificationApplication {
    PhysicianPortal = 1,
    BoardCert = 2,
    PreCert = 3,
    VerifyCert = 4
}

export class SystemNotificationResponse {
    systemNotificationId : number;
    systemNotificationApplicationId : SystemNotificationApplication;
    personKey : number;
    primaryActionTaken: boolean;
    permanentlyDismiss: boolean;
}